export var contentIsShorterThanMax = function contentIsShorterThanMax(descriptionParagraphs, maxVisibleDescriptionWords) {
  var _descriptionParagraph, _descriptionParagraph2;
  if (descriptionParagraphs.length !== 1) {
    return false;
  }
  var words = (_descriptionParagraph = (_descriptionParagraph2 = descriptionParagraphs[0]) === null || _descriptionParagraph2 === void 0 ? void 0 : _descriptionParagraph2.split(" ")) !== null && _descriptionParagraph !== void 0 ? _descriptionParagraph : [];
  return words.length <= maxVisibleDescriptionWords;
};